import { v4 as uuidv4 } from 'uuid';
import { JSONValue } from './json';

// Filter values must be JSON serializable, so they can be stored in the querystring.
export type FilterValue = JSONValue;

export type FilterOperatorComponentProps<T extends FilterValue> = {
  value: T;
  setValue: (T) => void;
  definition: FilterDefinition;
  operator: FilterOperator<T>;
};

export type FilterOperator<T extends FilterValue> = {
  id: string;
  label: React.ReactNode;

  // Can more than one instance of this type of filter exist at once?
  allowMultiple: boolean;

  initialValue: T;
  isValueValid: (T) => boolean;
  component: React.FunctionComponent<FilterOperatorComponentProps<T>>;
};

export type FilterDefinition = {
  id: string;
  label: React.ReactNode;
  operators: Array<FilterOperator<FilterValue>>;
};

// A filter where the value type is specified as a type parameter
export type FilterOfValueType<T extends FilterValue> = {
  id: string;
  definitionId: FilterDefinition['id'] | null;
  operatorId: FilterOperator<T>['id'] | null;
  value: T | null;
};

// A filter type that works for all fitlers, no matter the value they store inside.
export type Filter = FilterOfValueType<FilterValue>;

export const Filter = {
  create(
    definitionId: FilterDefinition['id'],
    operatorId: FilterOperator<FilterValue>['id'],
    value: FilterValue,
  ) {
    return {
      id: uuidv4().replace(/-/g, ''),
      definitionId,
      operatorId,
      value,
    };
  },
};
